module.exports = __webpack_public_path__ + "static/fonts/iconfont.0501fa7.woff";


//////////////////
// WEBPACK FOOTER
// ./static/csslib/iconfont/iconfont.woff?t=1639703065688
// module id = 74Qb
// module chunks = 193